<section style="margin:24px">
    <mat-card-header>
        <mat-card-title>Manage Permissions</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <p>Assign or remove permissions to this user</p>
    
        <mat-slide-toggle 
            (change)="onToggleChange($event, 'live_reporting')" 
            [checked]="permissionsLiveReporting"
            [disabled]="disabledPermissionLR"
        >Live Reporting
        </mat-slide-toggle>
        <br />
    
        <mat-slide-toggle
        (change)="onToggleChange($event, 'vendor_inventory')" 
        [checked]="permissionStatus"
        [disabled]="disabledVendorStatus"
        >Vendor Inventory
        </mat-slide-toggle>
        <br />

        <mat-slide-toggle
        (change)="onToggleChange($event, 'vendor_inventory_status_column')" 
        [checked]="permissionStatusColumn"
        [disabled]="disabledVendorStatus || !permissionStatus"
        >Vendor Inventory Status Column
        </mat-slide-toggle>
        <br />


        <mat-slide-toggle 
            (change)="onToggleChange($event, 'buybacks')" 
            [checked]="permissionsBuybacks"
            [disabled]="disabledPermissionBuybacks"
        >Employee Buy Back
        </mat-slide-toggle>
        <br />
        
        
        <br />
        <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
    </mat-card-content>

</section>
